
import jsonp from 'jsonp'

// ここを使う
//  http://zipcloud.ibsnet.co.jp/doc/api
function postToAddr(postCode) {
  return new Promise((resolve, reject) => {
    jsonp('https://zip-cloud.appspot.com/api/search?zipcode=' + postCode, null, (err, data) => {
      if(err) {
        console.error('postToAddr: network error', err)
        reject(err)
      }
      else if(data.results == null) {
        console.error('postToAddr: network error', data)
        reject(data.message)
      }
      else {
        console.log('PostToAdrr: submit successfully', data)
        const result = {
          addr1: data.results[0].address1,
          addr2: data.results[0].address2,
          addr3: data.results[0].address3,
          kana1: data.results[0].kana1,
          kana2: data.results[0].kana2,
          kana3: data.results[0].kana3,
        }
        resolve(result)
      }
    })
  })
}

postToAddr.sync = (postCode, resolve, reject) => {
  postToAddr(postCode).then(resolve).catch(reject || (() => {}))
}

export default {
  install(Vue, options) {
    Vue.prototype.$postToAddr = postToAddr
  }
}
